import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';

import { AuthService } from '../../../core/services/auth.service';
import { Profile } from '../../../models/profile.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  public isActive;
  public profile: Profile =  {} as Profile;
  constructor(
    private router: Router,
    public authService: AuthService,
    private localStorageService: LocalStorageService
  ) {
    this.authService.getSession().then(session => {
      this.isActive = session.isActive;
      if ( session.isActive ) {
        this.profile = session.profile;
      }
    });
  }
  logout() {
    this.authService.logout().then((data) => {
      this.router.navigate(['/']);
    })
  }
}
